import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  DropDown,
  EmptyListPage,
  ErrorSuccessModal,
  RadioContainer,
  TableHeader,
  TableLoader,
} from "../../../components/commons";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import { SearchIcon } from "../../../components/Icon";
import { SCHEDULING_MANAGER_LIST_HEADERS } from "../../../constant/tableHeadersConstants/schedulingConstants/schedulingListTableHeaders";
import SchedulingManagerViewNewRequestsListTable from "../../../components/Scheduling/ManagerView/SchedulingManagerViewNewRequestsListTable";
import {
  getManagerNewRequestList,
  resetManagerNewRequest,
  resetManagerNewRequestCount,
  resetRequestView,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
} from "../../../redux/scheduling";

import useDebounce from "../../../customHooks/useDebounce";

import ManagerNewRequestSorting from "../../../components/Scheduling/ManagerView/ManagerNewRequestSorting";
import NewRequestAndApprovalListFilter from "../../../components/Scheduling/ManagerView/NewRequestAndApprovalListFilter";
import { reverseDate } from "../../../utils/commonFunctions";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import { resetSession } from "../../../redux/auth";

const RADIO_OPTIONS = [
  {
    id: "Recently Added/Modified First",
    name: "Recently Added/Modified First",
    value: "",
  },

  {
    id: "Job Type - A to Z",
    name: "Job Type - A to Z",
    value: "asc",
  },
  {
    id: "Job Type - Z to A",
    name: "Job Type - Z to A",
    value: "desc",
  },
  {
    id: "User Type - A to Z",
    name: "User Type - A to Z",
    value: "asc",
  },
  {
    id: "User Type - Z to A",
    name: "User Type - Z to A",
    value: "desc",
  },
];

type AppProps = {
  fetching: boolean;
  token: string | null;
  schedulingManagerViewNewRequestsListing: any;
  clientList: any;
  dispatchNewRequestListing: (data: any) => void;
  dispatchResetManagerNewRequestListing: () => void;
  dispatchResetManagerNewRequestCount: () => void;
  history: any;
  managerNewRequestCount: number;
  dispatchResetRequestView: () => void;
  dispatchResetSession: () => void;
  dispatchResetSchedulingError: () => void;
  dispatchResetSchedulingSuccess: () => void;
  dispatchResetSchedulingMessage: () => void;
  dispatchResetSchedulingStatusCode: () => void;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  requestId?: any;
};

export type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};

const NewRequests = ({
  fetching,
  token,
  schedulingManagerViewNewRequestsListing,
  clientList,
  requestId,
  dispatchNewRequestListing,
  dispatchResetManagerNewRequestListing,
  history,
  managerNewRequestCount,
  dispatchResetManagerNewRequestCount,
  dispatchResetRequestView,
  dispatchResetSession,
  dispatchResetSchedulingError,
  dispatchResetSchedulingSuccess,
  dispatchResetSchedulingMessage,
  dispatchResetSchedulingStatusCode,
  message,
  error,
  statusCode,
  success,
}: AppProps) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<any[]>([]);
  const [searchClear, setSearchClear] = useState(false);
  const [selectedClient, setSelectedClient] = useState<string>("");
  const [finalClientList, setFinalClientList] = useState<
    DropDownItemType[] | []
  >([]);
  const [clientSelected, setClientSelected] = useState<any>({
    value: null,
    label: "Select Client",
  });
  const [sortingData, setSortingData] = useState({ name: "", value: "" });

  const [toggle, setToggle] = useState<boolean>(false);
  //filter data
  const [targetStartDate, setTargetStartDate] = useState("");
  const [targetEndDate, setTargetEndDate] = useState("");

  //sorting states
  const [targetDateValue, setTargetDateValue] = useState<string>("");
  const [employeeNameValue, setEmployeeNameValue] = useState<string>("");
  const [targetDate, setTargetDate] = useState<string>("");
  const [employeeName, setEmployeeName] = useState<string>("");
  const [allSorting, setAllSorting] = useState("");
  const [allSortingValue, setAllSortingValue] = useState("");
  useEffect(() => {
    dispatchResetManagerNewRequestListing();
    dispatchResetManagerNewRequestCount();
    dispatchResetRequestView();
    dispatchResetSchedulingError();
    dispatchResetSchedulingSuccess();
    dispatchResetSchedulingMessage();
    dispatchResetSchedulingStatusCode();
  }, []);
  const [searchData, setSearchData] = useState("");
  useEffect(() => {
    const finalClientListData = clientList?.map((data: any) => {
      return {
        value: data?.client_code,
        label: `(${data?.client_code}) ${data?.company_name}`,
      };
    });

    setFinalClientList(finalClientListData);
  }, [clientList]);

  const handleChangeClient = (client: any) => {
    setClientSelected({
      value: client?.value,
      label: client?.label,
    });
  };

  useEffect(() => {
    if (allSortingValue && (targetDate || employeeName)) {
      if (offset != 0) {
        setOffset(0);
      } else {
        let finalData = {
          token,
          search_term: searchData,
          clientCode: clientSelected?.value,
          limit,
          offset,
          employeeName,
          targetDate,
          allSortingValue,
          filterTargetStartDate: targetStartDate,
          filterTargetEndDate: targetEndDate,
        };
        if (token) {
          dispatchNewRequestListing(finalData);
        }
      }
    }
  }, [allSortingValue]);

  useEffect(() => {
    if (token) {
      let finalData: any = {
        token,
        search_term: searchData,
        employeeName,
        targetDate,
        limit,
        offset,
        allSortingValue,
        filterTargetStartDate: targetStartDate,
        filterTargetEndDate: targetEndDate,
      };

      if (offset < +managerNewRequestCount) {
        dispatchNewRequestListing(finalData);
      } else if (offset === 0 && managerNewRequestCount === 0) {
        dispatchNewRequestListing(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    if (schedulingManagerViewNewRequestsListing?.length === 0) {
      setData(schedulingManagerViewNewRequestsListing);
    }
    if (offset === 0) {
      setData(schedulingManagerViewNewRequestsListing);
    }
    else if (schedulingManagerViewNewRequestsListing?.length) {

      if (offset > 0) {
        setData((prv: any) => [
          ...prv,
          ...schedulingManagerViewNewRequestsListing,
        ]);
      } else {
        if (schedulingManagerViewNewRequestsListing?.length) {
          setData([...schedulingManagerViewNewRequestsListing]);
        }
      }
    }
  }, [schedulingManagerViewNewRequestsListing]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [schedulingManagerViewNewRequestsListing]);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +managerNewRequestCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (schedulingManagerViewNewRequestsListing?.length > 0) {
          if (!fetching && offset < +managerNewRequestCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (token && clientSelected?.value && (employeeName || targetDate)) {
      let finalData: any = {
        token,
        clientCode: clientSelected?.value,
        search_term: searchData,
        employeeName,
        targetDate,
        allSortingValue,
        filterTargetStartDate: targetStartDate,
        filterTargetEndDate: targetEndDate,
      };
      if (offset === 0) {
        dispatchNewRequestListing(finalData);
      } else {
        setOffset(0);
      }
    }
  }, [employeeName, targetDate]);

  useDebounce(
    () => {
      if (searchData) {
        fetchNewData();
      }
    },
    500,
    [searchData]
  );

  const fetchNewData = () => {
    let finalData = {
      token,
      search_term: searchData,
      clientCode: clientSelected?.value,
      limit,
      offset,
      employeeName,
      targetDate,
      allSortingValue,
      filterTargetStartDate: targetStartDate,
      filterTargetEndDate: targetEndDate,
    };
    if (token) {
      setSearchClear(true);

      if (offset === 0) {
        dispatchNewRequestListing(finalData);
        setOffset(0);
      } else {
        setOffset(0);
      }
    }
  };

  useEffect(() => {
    if (searchClear) {
      let finalData = {
        token,
        search_term: searchData,
        clientCode: clientSelected?.value,
        limit,
        offset: 0,
        employeeName,
        targetDate,
        allSortingValue,
        filterTargetStartDate: targetStartDate,
        filterTargetEndDate: targetEndDate,
      };
      if (searchData?.length === 0) {
        dispatchResetManagerNewRequestListing();
        dispatchNewRequestListing(finalData);
        setOffset(0);
      }
    }
  }, [searchClear, searchData]);

  const handleSearch = (e: any) => {
    setSearchData(e.target.value);
  };

  const applyFilter = (data: any) => {
    dispatchResetManagerNewRequestListing();
    dispatchResetManagerNewRequestCount();

    if (offset === 0) {
      let finalData = {
        token,
        search_term: searchData,
        clientCode: clientSelected?.value,
        limit,
        offset: 0,
        employeeName,
        targetDate,
        allSortingValue,
        filterTargetStartDate: data?.targetStartDate,
        filterTargetEndDate: data?.targetEndDate,
      };
      if (token && (data?.targetStartDate || data?.targetEndDate)) {
        dispatchNewRequestListing(finalData);
      }
    } else {
      if (token && (data?.targetStartDate || data?.targetEndDate)) {
        setOffset(0);
      }
    }
  };

  const clearFilter = () => {
    setTargetStartDate("");
    setTargetEndDate("");
    let finalData = {
      token,
      search_term: searchData,
      clientCode: clientSelected?.value,
      limit,
      offset: 0,
      employeeName,
      targetDate,
      allSortingValue,
    };
    if (token) {
      dispatchNewRequestListing(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
            statusCode={statusCode}
          />
        );
      }
      else if (error === "The job associated with the provided job_id is Closed." && statusCode === 400) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={"This job has been closed"}
            buttonText="OK"
            onPress={() => {
              dispatchResetSchedulingError();
              dispatchResetSchedulingMessage();
              dispatchResetSchedulingStatusCode();
              dispatchResetSchedulingSuccess();
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
          />
        );
      }
    }


    return false;
  };

  return (
    <div className="row">
      <div className="col-md-12 ">
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "1rem",
            }}
          >
            <div className="left-header" style={{ width: "40%" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  <div className="heading mb-2"> New Requests</div>
                  {!fetching && (
                    <div className="sub-heading mt-0">
                      Total {managerNewRequestCount} records found
                    </div>
                  )}
                </div>

              </div>
            </div>
            <div className="right-header">
              <div
                className="col-md-7 position-relative"
                style={{ marginRight: "-8px" }}
              >
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search..."
                  onChange={handleSearch}
                  style={{ paddingLeft: "35px" }}
                />
              </div>

              <div className="mr-1 d-flex">

                <div className=" mr-2">
                  <NewRequestAndApprovalListFilter
                    applyFilter={applyFilter}
                    targetStartDate={targetStartDate}
                    setTargetStartDate={setTargetStartDate}
                    targetEndDate={targetEndDate}
                    setTargetEndDate={setTargetEndDate}
                    clearFilter={clearFilter}
                  />
                </div>

                <ManagerNewRequestSorting
                  targetDateValue={targetDateValue}
                  setTargetDateValue={setTargetDateValue}
                  employeeNameValue={employeeNameValue}
                  setEmployeeNameValue={setEmployeeNameValue}
                  employeeName={employeeName}
                  targetDate={targetDate}
                  setTargetDate={setTargetDate}
                  setEmployeeName={setEmployeeName}
                  allSorting={allSorting}
                  setAllSorting={setAllSorting}
                  allSortingValue={allSortingValue}
                  setAllSortingValue={setAllSortingValue}
                />
              </div>
            </div>
          </div>
        </div>

        {fetching && offset === 0 ? (
          <TableLoader Rows={10} ColumnPerRow={7} />
        ) : schedulingManagerViewNewRequestsListing?.length > 0 ? (
          <div className="jobsType" style={{ overflowX: "scroll" }}>
            <table className="table table-bordered thead-light">
              <thead className="text-start sticky-table-header-without-zindex">
                <TableHeader tableHeader={SCHEDULING_MANAGER_LIST_HEADERS} />
              </thead>
              <tbody>
                <SchedulingManagerViewNewRequestsListTable
                  data={data}
                  tableHeader={SCHEDULING_MANAGER_LIST_HEADERS}
                  history={history}
                />
                {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                <div style={{ display: fetching ? "none" : "inline" }}>
                  <ScrollToTop />
                </div>
              </tbody>
            </table>
          </div>
        ) : (
          fetching === false &&
          schedulingManagerViewNewRequestsListing?.length === 0 && (
            <div className="mt-5">
              <EmptyListPage title="No New Request Found!" imageWidth="30%" />
            </div>
          )
        )}
      </div>
      {handleErrorModal()}
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  clientList: state.auth.assignedClientsToUserList,
  fetching: state.scheduling.fetching,
  schedulingManagerViewNewRequestsListing:
    state.scheduling.schedulingManagerViewNewRequestsListing,
  managerNewRequestCount: state.scheduling.managerNewRequestCount,
  message: state.scheduling.message,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  success: state.scheduling.success,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchNewRequestListing: (data: any) =>
    dispatch(getManagerNewRequestList(data)),
  dispatchResetManagerNewRequestListing: () =>
    dispatch(resetManagerNewRequest()),
  dispatchResetManagerNewRequestCount: () =>
    dispatch(resetManagerNewRequestCount()),
  dispatchResetRequestView: () => dispatch(resetRequestView()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSchedulingError: () => dispatch(resetSchedulingError()),
  dispatchResetSchedulingSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetSchedulingMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetSchedulingStatusCode: () =>
    dispatch(resetSchedulingStatusCode()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewRequests);
